import React, { useState } from 'react';
import { Box, Flex, TextHeadingThree, ClickableElement } from '@cko/primitives';
import styled from 'styled-components';
const Header = styled(Flex) `
  align-items: center;
  height: 52px;
  width: 100%;
`;
const Tab = styled(ClickableElement) `
  h3 {
    color: ${(props) => (props.selected ? 'var(--base-text-good)' : 'inherit')};
  }

  &:focus {
    box-shadow: none;
  }

  &:not(:first-child) {
    margin-left: var(--layout-stamp);
  }
`;
const View = ({ children, index, visibleIndex, }) => {
    return (React.createElement("div", { hidden: visibleIndex !== index, id: `tabpanel-${index}`, role: "tabpanel" }, visibleIndex === index && React.createElement(React.Fragment, null, children)));
};
export const PanelWithHeader = ({ children, titles }) => {
    const [visibleIndex, setVisibleIndex] = useState(0);
    const isSingle = titles.length === 1;
    return (React.createElement(Box, { p: "var(--layout-sandgrain)" },
        React.createElement(Header, null,
            isSingle && (React.createElement(TextHeadingThree, { mr: "var(--layout-stamp)", mx: "var(--layout-sandgrain)" }, titles[0])),
            !isSingle &&
                titles.map((title, index) => (React.createElement(Tab, { selected: visibleIndex === index, onClick: () => {
                        setVisibleIndex(index);
                    }, key: title, "data-testid": `tab-${title}`, id: `tab-${index}`, "aria-controls": `tabpanel-${index}` },
                    React.createElement(TextHeadingThree, { mr: "var(--layout-stamp)", mx: "var(--layout-sandgrain)" }, title))))),
        React.Children.toArray(children).map((child, index) => (React.createElement(View, { index: index, visibleIndex: visibleIndex, key: `view-${titles[index]}` }, child)))));
};
